module.exports = __webpack_public_path__ + "assets/img/btm-logo1.b3553ead.png";